import { render, staticRenderFns } from "./openApp.vue?vue&type=template&id=f48f2348&scoped=true&"
import script from "./openApp.vue?vue&type=script&lang=js&"
export * from "./openApp.vue?vue&type=script&lang=js&"
import style0 from "./openApp.vue?vue&type=style&index=0&id=f48f2348&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f48f2348",
  null
  
)

export default component.exports